import { UnscanRptConstants } from '../constants';

export function UnscanRpt(state = {}, action) {
    switch (action.type) {
        case UnscanRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case UnscanRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case UnscanRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case UnscanRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case UnscanRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case UnscanRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case UnscanRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}